module.exports = {
          srcSet: __webpack_public_path__ + "983d49cf88c311ea459f6fb2717f530f-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "983d49cf88c311ea459f6fb2717f530f-1168.png",width: 1168,height: 234}],
          src: __webpack_public_path__ + "983d49cf88c311ea459f6fb2717f530f-1168.png",
          toString:function(){return __webpack_public_path__ + "983d49cf88c311ea459f6fb2717f530f-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AABCMf0DRTT/M2ZU/jxtW/86a1n/SXZk/1uCcP9CcV/+AEEx/wBDMvsAAEEw+w1MO/9Fc2H+THhm/z9uXP9Re2n/Sndk/096aP4JSTj/AEEw+cVsJPfDYes8AAAAAElFTkSuQmCC",
          width: 1168,
          height: 234
        }